export default {
  api: {
    basePath: `${process.env.REACT_APP_REMOTE_SERVER}`,
  },
  apiAuthentication: {
    basePath: `${process.env.REACT_APP_REMOTE_SERVER_AUTHENTICATION}`,
  }
};
